export default function () {
    return createPendingApprovalsGrid();
}

const createPendingApprovalsGrid = () => {
    return new Promise(resolve => {
        let $pendingApprovalGrid = $('.pending-approvals-grid');
        if ($pendingApprovalGrid.length) {
            $pendingApprovalGrid.kendoGrid({
                dataSource: {
                    autoSync: false,
                    schema: {
                        model: {
                            id: 'rowId',
                            fields: {
                                empNum: {
                                    type: 'number',
                                    editable: false,
                                    nullable: false
                                },
                                company: {
                                    type: 'number',
                                    editable: false,
                                    nullable: false
                                },
                                itemType: {
                                    type: 'string',
                                    editable: false,
                                    nullable: false
                                },
                                itemDesc: {
                                    type: 'string',
                                    editable: false,
                                    nullable: false
                                },
                                itemDatestamp: {
                                    type: 'string',
                                    editable: false
                                },
                                itemStatus: {
                                    type: 'string',
                                    editable: false
                                },
                                itemLink: {
                                    type: 'string',
                                    editable: false
                                }
                            }
                        }
                    },
                    transport: {
                        read: {
                            dataType: 'json',
                            type: 'GET',
                            url: '/Account/UserPage/GetPendingApprovals'
                        },
                        parameterMap(data, type) {
                            if (type === 'read') {
                                //something
                            }
                            return data;
                        }
                    }
                },
                columns: [
                    {
                        title: 'Type',
                        field: 'itemType',
                        headerAttributes: {style: 'white-space: normal'}
                    },
                    {
                        title: 'Item',
                        field: 'itemDesc',
                        headerAttributes: {style: 'white-space: normal'}
                    },
                    {
                        title: 'Date Created',
                        field: 'itemDatestamp',
                        headerAttributes: {style: 'white-space: normal'},
                        // template : function(dataItem){
                        //     return 
                        // }
                    },
                    {
                        title: 'Approval Status',
                        field: 'itemStatus',
                        headerAttributes: {style: 'white-space: normal'}
                    },
                    {
                        title: 'Link',
                        field: 'itemLink',
                        headerAttributes: {style: 'white-space: normal'},
                        template(dataItem) {
                            return `<a href="${dataItem.itemLink}" target="_blank">Go to Page <span class="k-icon k-i-hyperlink-open"></span></a>`
                        }
                    }
                ],
                dataBound(e) {
                },
                resizable: false,
                mobile: false,
                scrollable: true,
                sortable: false,
                filterable: false,
                pageable: {
                    alwaysVisible: false,
                    pageSizes: true,
                    buttonCount: 20
                },
                noRecords: {
                    template: "There are no pending approvals."
                }
            });
            resolve();
        } else {
            resolve();
        }
    })
}